import { NotificationData, isNotificationRead } from "./Notification";
import { PlayerContextState } from "./PlayerContext";
import { getTotalSecondsPlayed } from "./timetick/TotalTimePlayed";

export function getNotificationById(
  state: PlayerContextState,
  id: string,
): NotificationData | undefined {
  return state.global.notifications.find(
    (notification) => notification.id == id,
  );
}

export function getNotificationByGroupAndItem(
  state: PlayerContextState,
  group: string,
  item: string,
): NotificationData | undefined {
  return state.global.notifications.find(
    (notification) => notification.group == group && notification.item == item,
  );
}

export function getNotificationsByGroup(
  state: PlayerContextState,
  group: string,
): NotificationData[] {
  return state.global.notifications.filter(
    (notification) => notification.group == group,
  );
}

export function getUnreadNotificationsByGroup(
  state: PlayerContextState,
  group: string,
): NotificationData[] {
  return getNotificationsByGroup(state, group).filter(
    (notification) => !isNotificationRead(notification),
  );
}

export function triggerNotification(
  state: PlayerContextState,
  group: string,
  item: string,
): PlayerContextState {
  const previousNotification = getNotificationByGroupAndItem(
    state,
    group,
    item,
  );
  if (previousNotification) {
    previousNotification.globalTimestampTriggered =
      getTotalSecondsPlayed(state);
    return state;
  }

  state.global.notifications.push({
    id: Math.random().toString(),
    group,
    item,
    globalTimestampTriggered: getTotalSecondsPlayed(state),
    globalTimestampRead: undefined,
  });
  return state;
}

export function markNotificationAsRead(
  state: PlayerContextState,
  group: string,
  item: string,
): PlayerContextState {
  const previousNotification = getNotificationByGroupAndItem(
    state,
    group,
    item,
  );
  if (previousNotification) {
    if (!isNotificationRead(previousNotification)) {
      previousNotification.globalTimestampRead = getTotalSecondsPlayed(state);
    }
  }
  return state;
}
